import "./ProfileForm.css"
import React from 'react'
import UIButton from "./UIButton"
import Window from "./Window"
import X from "./X"
import { isValidMBTI } from "../store/functions"


export class ProfileForm extends React.Component {

  constructor(props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.state = {
      name: "",
      mbti: "",
      color: null,
    }
  }

  handleChange(key) {
    return (e)=> {
      this.setState({ [key]: e.target.value }, ()=> {
        const valid = this.state.name.length && isValidMBTI(this.state.mbti)
        this.setState({ valid })
      })
    }
  }

  handleSubmit(e) {
    e.preventDefault()
    if (!this.state.valid)
      return

    this.props.onSave(this.state)
    this.setState({
      name: "",
      mbti: "",
      color: null,
      valid: false,
    })
  }

  handleKeyDown(e) {
    if (e.keyCode === 13 && this.state.valid)
      this.handleSubmit(e)
  }

  render() {
    return (
      <Window className="ProfileForm" width={400} height={250}>
        {
          this.props.showClose ?
            <X onClick={this.props.onCancel} />
          : null
        }
        <form onKeyDown={this.handleKeyDown.bind(this)}>
          <div>
            <input 
              type="text" 
              value={this.state.name}
              placeholder="Enter name"
              onChange={this.handleChange("name")}
              autoFocus />
          </div>
          <div>
            <input 
              type="text" 
              value={this.state.mbti} 
              placeholder="Enter MBTI"
              onChange={this.handleChange("mbti")} />
          </div>
          <footer>
            <UIButton
              height={30}
              cornerWidth={10}
              onClick={this.handleSubmit}
              disabled={!this.state.valid}>
              &lt;Enter&gt;
            </UIButton>
            {
              !this.props.showClose ?
                <p>
                  What's an MBTI? Find out <a href="https://www.16personalities.com/free-personality-test" target="_blank">here</a>.
                </p>
              : null
            }
          </footer>
        </form>
      </Window>
    )
  }
}

ProfileForm.defaultProps = {
  showClose: true,
}

export default ProfileForm


// WEBPACK FOOTER //
// ./src/components/ProfileForm.js